const isNumber = value => typeof value === 'number'
const isString = value => typeof value === 'string'
const isFunc = value => typeof value === 'function'
const createProperty = (value, checkFunc, defaultValue) => {
  if (typeof checkFunc !== 'function') {
    throw new Error('Incorrect argument checkFunc=[function]')
  }

  return {
    value: checkFunc(value) ? value : defaultValue,
    writable: false,
    configurable: false,
    enumerable: false,
  }
}

class Progress {
  value = 0

  label = null

  tooltip = null

  className = null

  onClick = undefined

  constructor({ value, label, tooltip, className, onClick }) {
    Object.defineProperties(this, {
      value: createProperty(value, isNumber, 0),
      label: createProperty(label, isString, null),
      tooltip: createProperty(tooltip, isString, null),
      className: createProperty(className, isString, null),
      onClick: createProperty(onClick, isFunc, undefined),
    })
    Object.freeze(this)
  }
}

export default Progress
